import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Eye } from "lucide-react";
import { Button } from "@/components/ui/button";
import PartnerDashboard from "@/pages/PartnerDashboard";
import PublisherDashboard from "@/pages/PublisherDashboard";

// "View as partner": renders the exact partner/publisher dashboard for any company, read-only.
export default function PartnerPreview({ api, backTo }) {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.getPreview(companyId, {}).then((r) => setMeta(r.data)).catch((e) => setError(e.response?.data?.detail || "Could not load preview"));
  }, [companyId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchDashboard = (params) => api.getPreview(companyId, params).then((r) => ({ data: r.data.data }));
  const fetchDates = () => api.getAvailableDates({});

  return (
    <div data-testid="partner-preview-page">
      <div className="mx-4 md:mx-6 mt-4 rounded-lg border border-blue-200 bg-blue-50 px-4 py-2.5 flex flex-wrap items-center gap-3" data-testid="partner-preview-banner">
        <Button variant="ghost" size="sm" className="h-7 px-2 text-blue-700" onClick={() => navigate(backTo)} data-testid="partner-preview-back">
          <ArrowLeft size={14} className="mr-1" /> Back
        </Button>
        <Eye size={16} className="text-blue-600" />
        <span className="text-xs font-semibold text-blue-800">
          Viewing as {meta?.company_name || "partner"} {meta && <span className="font-normal text-blue-600">({meta.type === "slcp" ? "SLCP publisher view" : "SLDP partner view"})</span>}
        </span>
        <span className="text-xs text-blue-600">Read-only preview of exactly what this partner sees.</span>
        {meta?.web_indexing_redacted && (
          <span className="text-xs font-medium text-slate-600 bg-white border border-slate-200 rounded-full px-2 py-0.5" data-testid="preview-redacted-note">Web-indexing earnings unavailable</span>
        )}
      </div>
      {error && <p className="m-6 text-sm text-red-600" data-testid="partner-preview-error">{error}</p>}
      {meta && meta.type === "slcp" && <PublisherDashboard fetchDashboard={fetchDashboard} preview />}
      {meta && meta.type === "sldp" && <PartnerDashboard fetchDashboard={fetchDashboard} fetchDates={fetchDates} preview />}
    </div>
  );
}
